<template>
  <div class="legend-content px-3 pb-3 pt-2">
    <div v-if="!legends || legends.length === 0" class="text-center grey--text py-2" style="font-size: 12px; font-style: italic;">
      Chưa có chú giải
    </div>
    <div v-for="item in legends" :key="item.id" class="legend-item mt-2">
      
      <!-- Root Item -->
      <div v-if="item.type === 'list'" class="d-flex align-center" :style="item.children && item.children.length ? 'cursor: pointer' : ''" @click="item.children && item.children.length ? toggleCollapse(item.id) : null">
        <v-icon v-if="item.children && item.children.length" small class="mr-1">
          {{ isCollapsed(item.id) ? 'mdi-menu-right' : 'mdi-menu-down' }}
        </v-icon>
        <div v-if="item.color" class="color-box" :style="{ backgroundColor: item.color }" :class="{'ml-2': !(item.children && item.children.length)}"></div>
        <span class="text-body-2" :class="{'font-weight-bold': item.children && item.children.length, 'ml-2': item.color || !(item.children && item.children.length)}">{{ item.title }}</span>
      </div>
      
      <!-- Image Type -->
      <div v-else-if="item.type === 'image'" class="mt-1">
        <div class="d-flex align-center mb-1" :style="item.children && item.children.length ? 'cursor: pointer' : ''" @click="item.children && item.children.length ? toggleCollapse(item.id) : null">
          <v-icon v-if="item.children && item.children.length" small class="mr-1">
            {{ isCollapsed(item.id) ? 'mdi-menu-right' : 'mdi-menu-down' }}
          </v-icon>
          <span v-if="item.title" class="text-body-2 d-block" :class="{'font-weight-bold': item.children && item.children.length}">{{ item.title }}</span>
        </div>
        <!-- Smart Flex layout for images to auto wrap -->
        <div class="d-flex flex-wrap align-start">
          <img :src="getImageUrl(item.image_path)" class="legend-image" @load="$emit('calc-height')" />
        </div>
      </div>

      <!-- Children Items -->
      <div v-if="item.children && item.children.length > 0" v-show="!isCollapsed(item.id)" class="pl-4 mt-1 border-left-child">
         <div v-for="child in item.children" :key="child.id" class="legend-child-item mb-1 mt-1">
            <div v-if="child.type === 'list'" class="d-flex align-center">
              <div v-if="child.color" class="color-box" :style="{ backgroundColor: child.color }"></div>
              <span class="ml-2 text-body-2">{{ child.title }}</span>
            </div>
            <div v-else-if="child.type === 'image'" class="mt-1 d-flex flex-wrap align-start">
              <span v-if="child.title" class="text-body-2 mr-2 mb-1">{{ child.title }}</span>
              <img :src="getImageUrl(child.image_path)" class="legend-image" @load="$emit('calc-height')" />
            </div>
         </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'LegendContent',
  props: {
    legends: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      collapsedGroups: []
    }
  },
  methods: {
    toggleCollapse(id) {
      const index = this.collapsedGroups.indexOf(id)
      if (index > -1) {
        this.collapsedGroups.splice(index, 1) // expand
      } else {
        this.collapsedGroups.push(id) // collapse
      }
      this.$nextTick(() => {
        this.$emit('calc-height')
      })
    },
    isCollapsed(id) {
      return this.collapsedGroups.includes(id)
    },
    getImageUrl(path) {
      if (!path) return ''
      if (path.startsWith('http')) return path
      let baseUrl = process.env.VUE_APP_API_URL || ''
      if (baseUrl.endsWith('/api/') || baseUrl.endsWith('/api')) {
        baseUrl = baseUrl.replace(/\/api\/?$/, '')
      }
      return baseUrl ? `${baseUrl}${path}` : path
    }
  }
}
</script>

<style scoped>
.color-box {
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  flex-shrink: 0;
}
.legend-item {
  word-break: break-word;
}
.legend-image {
  max-width: 100%;
  height: auto;
  display: block;
  border-radius: 4px;
}
.border-left-child {
  border-left: 2px solid #e0e0e0;
}
</style>
